<mat-form-field appearance="fill" class="custom-tel d-flex w-100" [class.mat-form-field-invalid]="isInvalid">
  <img width="24" height="24" [src]="pathIcons + selectedCountry.code + '.svg'" alt="" />
  <mat-select
    disableOptionCentering
    [(ngModel)]="selectedCountry"
    (opened)="phoneSearch.focus()"
    [disabled]="disabled"
    (selectionChange)="updateValue()"
    (closed)="phoneSearch.value = ''"
    required
  >
    <mat-form-field appearance="standard" class="w-100 phone-custom-search-field">
      <input matInput #phoneSearch type="text" (keydown)="$event.stopPropagation()" [placeholder]="placeholderSearch" />
    </mat-form-field>
    <mat-option *ngFor="let option of getCountriesList(phoneSearch.value); let i1 = index" [value]="option" class="phone-custom-option">
      <img class="country-pict me-2" width="24" height="24" [src]="'assets/shared/img/flag/' + option.code + '.svg'" alt="" />
      {{ countryName(option) }}
      <span class="secondary-text"> +{{ option.phoneCode }}</span>
    </mat-option>
  </mat-select>
  <div class="phone-code">+{{ selectedCountry.phoneCode }}</div>
  <input
    [(ngModel)]="phoneWithoutCode"
    matInput
    (ngModelChange)="onPhoneNumberChange()"
    (blur)="onTouched()"
    [required]="required"
    (keypress)="onInputKeyPress($event)"
    [attr.maxLength]="maxLength"
    [attr.minLength]="minLength"
    [disabled]="disabled"
    [placeholder]="placeholder"
    (click)="$event.stopPropagation()"
    #focusable
    type="tel"
    name="custom_phone"
    autocomplete="off"
    class="phone-without-code"
    (blur)="onBlur()"
  />
</mat-form-field>
<mat-error *ngIf="required && !phoneWithoutCode"> {{ errorRequired }}</mat-error>
<mat-error *ngIf="phoneNumber.length < minLength && phoneWithoutCode.length > 0">
  {{ 'errorCodes.MIN_LENGTH' | transloco }}
</mat-error>
